import React from 'react';

const ModalIcon = () => (
  <svg width="20" height="20" viewBox="0 0 20 20" fill="none" xmlns="http://www.w3.org/2000/svg">
    <path
      d="M8.80648 13.8691H11.5251C14.6968 13.8691 14.3757 13.8691 14.3757 11.2441V8.99414C14.3757 6.36914 14.6968 6.36914 11.5251 6.36914H8.80648C5.63477 6.36914 5.63477 6.36914 5.63477 8.99414V10.1191V11.2441C5.63477 13.8691 5.63477 13.8691 8.80648 13.8691Z"
      fill="currentColor"
      stroke="currentColor"
      strokeWidth="1.5"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
    <path
      d="M14.168 16.6673H5.83464C2.5013 16.6673 1.66797 15.834 1.66797 12.5007V7.50065C1.66797 4.16732 2.5013 3.33398 5.83464 3.33398H14.168C17.5013 3.33398 18.3346 4.16732 18.3346 7.50065V12.5007C18.3346 15.834 17.5013 16.6673 14.168 16.6673Z"
      stroke="currentColor"
      strokeWidth="1.5"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
  </svg>
);

export default ModalIcon;
